import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eKeHoachHocLaiActionIds, IKeHoachHocLaiActions } from "../../action-types/ke-hoach-hoc-lai/IKeHoachHocLaiActions";
import { keHoachHocLaiActions } from "../../actions/ke-hoach-hoc-lai/keHoachHocLaiActions";
import { keHoachMonHocLaiApi } from "../../../api/ke-hoach/keHoachMonHocLaiApi";
import { IKeHoachMonHocLaiSelectRequest } from "../../../model/request/ke-hoach-hoc-lai/IKeHoachMonHocLaiSelectRequest";
import { lopTinChiApi } from "../../../api/lop-tin-chi/lopTinChiApi";
import { IPhamViDangKyLop } from "../../../model/respone/lop-tin-chi/IPhamViDangKyLop";
import { ILopTinChiPhamViUpdateRequest } from "../../../model/request/lop-tin-chi/ILopTinChiPhamViUpdateRequest";
import { IKeHoachMonAddRequest } from "../../../model/request/ke-hoach/IKeHoachMonAddRequest";
import { IKeHoachMonHocLaiUpdateInfoSuKienRequest } from "../../../model/request/ke-hoach-hoc-lai/IKeHoachMonHocLaiUpdateInfoSuKienRequest";
import { ILopTinChiViewModel } from "../../../model/respone/lop-tin-chi/ILopTinChiViewModel";

export function* keHoachHocLaiSaga(): any {
    yield takeLatest(eKeHoachHocLaiActionIds.LOAD_START, loadWorker);
    yield takeLatest(eKeHoachHocLaiActionIds.SAVE_PHAM_VI_START, savePhamViWorker);
    yield takeLatest(eKeHoachHocLaiActionIds.ADD_MONHOC_START, addMonHocWorker);
    yield takeLatest(eKeHoachHocLaiActionIds.UPDATE_INFO_SU_KIEN_START, updateInfoSuKienWorker);
    yield takeLatest(eKeHoachHocLaiActionIds.UPDATE_LOP_TIN_CHI_START, updateLopTinChiWorker);
}

function* loadWorker(action: IKeHoachHocLaiActions): any {
    const res: IBaseRespone = yield call(keHoachMonHocLaiApi.Select, action.payload as IKeHoachMonHocLaiSelectRequest);
    if (res.is_success) {
        yield put(keHoachHocLaiActions.LOAD_SUCCESS(res.data));
    } else {
        yield put(keHoachHocLaiActions.LOAD_ERROR(res.message ?? "Có lỗi"));
    }
}

function* savePhamViWorker(action: IKeHoachHocLaiActions): any {
    const request = action.payload as ILopTinChiPhamViUpdateRequest;
    const res: IBaseRespone = yield call(lopTinChiApi.UpdatePhamViNew, request);
    if (res.is_success) {
        yield put(keHoachHocLaiActions.SAVE_PHAM_VI_SUCCESS(res.data));
    } else {
        yield put(keHoachHocLaiActions.SAVE_PHAM_VI_ERROR(res.message ?? "Có lỗi"));
    }
}


function* addMonHocWorker(action: IKeHoachHocLaiActions): any {
    const res: IBaseRespone = yield call(keHoachMonHocLaiApi.AddMonHoc, action.payload as IKeHoachMonAddRequest);
    if (res.is_success) {
        yield put(keHoachHocLaiActions.ADD_MONHOC_SUCCESS(res.data));
    } else {
        yield put(keHoachHocLaiActions.ADD_MONHOC_ERROR(res.message ?? "Có lỗi"));
    }
}

function* updateInfoSuKienWorker(action: IKeHoachHocLaiActions): any {
    const request = action.payload as IKeHoachMonHocLaiUpdateInfoSuKienRequest[];
    const res: IBaseRespone = yield call(keHoachMonHocLaiApi.UpdateInfoSuKien, request);
    if (res.is_success) {
        yield put(keHoachHocLaiActions.UPDATE_INFO_SU_KIEN_SUCCESS(res.data));
    } else {
        yield put(keHoachHocLaiActions.UPDATE_INFO_SU_KIEN_ERROR(res.message ?? "Có lỗi"));
    }
}

function* updateLopTinChiWorker(action: IKeHoachHocLaiActions): any {
    const request = action.payload as ILopTinChiViewModel;
    const res: IBaseRespone = yield call(lopTinChiApi.Update, request);
    if (res.is_success) {
        yield put(keHoachHocLaiActions.UPDATE_LOP_TIN_CHI_SUCCESS(res.data));
    } else {
        yield put(keHoachHocLaiActions.UPDATE_LOP_TIN_CHI_ERROR(res.message ?? "Có lỗi"));
    }
}